import { useEffect, useState } from "react";
import { setSearch, setSort } from "../redux/features/filter/filterSlice";
import { useDispatch } from 'react-redux';


export default function Filter() {
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState("");
    const [sortValue, setSortValue] = useState("");

    // debounce functionality
    useEffect(() => {
      const timer = setTimeout(() => {
        dispatch(setSearch(inputValue));
      }, 500);
  
      return () => {
        clearTimeout(timer);
      };
    }, [dispatch, inputValue]);
  
    
    const handleInputChange = (event) => {
      setInputValue(event.target.value);
    };

    const changeHandler = (e)=>{
        setSortValue(e.target.value)
        dispatch(setSort(e.target.value))
    }
    return (
        <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
            <h1 className="lws-section-title">All Available Jobs</h1>
            <div className="flex gap-4">
                <div className="search-field group flex-1">
                    <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                    <input type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" 
                    value={inputValue}
                    onChange={handleInputChange}
                    />
                </div>
                <select id="lws-sort" name="sort" autoComplete="sort" className="flex-1"
                value={sortValue}
                onChange={changeHandler}
                >
                    <option value={"none"}>Default</option>
                    <option value={"ace"}>Salary (Low to High)</option>
                    <option value={"desc"}>Salary (High to Low)</option>
                </select>
            </div>
        </div>
    )
};